/**
 * Task-type vocabulary (v3 homepage) — the prototype V3_TASK_META, shared by
 * Hero / PriorityStack / anything that phrases a CTA from a task's TYPE. The
 * homepage must NEVER assume "evaluation": each type carries its icon, the ask
 * (what the user is being asked to do), the verb-noun for CTAs, and a rough
 * time estimate for the guided-start copy.
 *
 * Keyed by the task-type LABEL (workflow `task_type` / doc rows) with
 * flow_type aliases (EVALUATION/CLASSIFICATION/…) so both data shapes resolve.
 */
const TASK_META = {
  'Job evaluation': { icon: 'balance', ask: 'Evaluate this role', verb: 'evaluation', mins: 15 },
  'Document review': { icon: 'rate_review', ask: 'Review this document', verb: 'review', mins: 5 },
  'Re-classification': { icon: 'sync', ask: 'Re-classify this role', verb: 're-classification', mins: 12 },
  Classification: { icon: 'category', ask: 'Classify this role', verb: 'classification', mins: 10 },
  Calibration: { icon: 'tune', ask: 'Calibrate this role in context', verb: 'calibration', mins: 8 },
};
// flow_type (Report/homeResume) → the same entries.
const FLOW_ALIAS = {
  EVALUATION: 'Job evaluation',
  CLASSIFICATION: 'Classification',
  RECLASSIFICATION: 'Re-classification',
  'RE-CLASSIFICATION': 'Re-classification',
  CALIBRATION: 'Calibration',
};
const FALLBACK = { icon: 'edit_document', ask: 'Open this task', verb: 'task', mins: 10 };

export function taskMeta(type) {
  if (!type) return FALLBACK;
  const key = TASK_META[type] ? type : FLOW_ALIAS[String(type).toUpperCase()];
  return (key && TASK_META[key]) || FALLBACK;
}
